/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterCompanyAddPost } from '../fn/company/api-master-company-add-post';
import { ApiMasterCompanyAddPost$Params } from '../fn/company/api-master-company-add-post';
import { apiMasterCompanyDeleteGet } from '../fn/company/api-master-company-delete-get';
import { ApiMasterCompanyDeleteGet$Params } from '../fn/company/api-master-company-delete-get';
import { apiMasterCompanyEditPost } from '../fn/company/api-master-company-edit-post';
import { ApiMasterCompanyEditPost$Params } from '../fn/company/api-master-company-edit-post';
import { apiMasterCompanyGetActiveGet } from '../fn/company/api-master-company-get-active-get';
import { ApiMasterCompanyGetActiveGet$Params } from '../fn/company/api-master-company-get-active-get';
import { apiMasterCompanyGetAllGet } from '../fn/company/api-master-company-get-all-get';
import { ApiMasterCompanyGetAllGet$Params } from '../fn/company/api-master-company-get-all-get';
import { apiMasterCompanyGetByCriteriaPost } from '../fn/company/api-master-company-get-by-criteria-post';
import { ApiMasterCompanyGetByCriteriaPost$Params } from '../fn/company/api-master-company-get-by-criteria-post';
import { apiMasterCompanyGetByIdGet } from '../fn/company/api-master-company-get-by-id-get';
import { ApiMasterCompanyGetByIdGet$Params } from '../fn/company/api-master-company-get-by-id-get';
import { Company } from '../models/company';
import { CompanyApiRespModel } from '../models/company-api-resp-model';
import { StringApiRespModel } from '../models/string-api-resp-model';

@Injectable({ providedIn: 'root' })
export class CompanyService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterCompanyAddPost()` */
  static readonly ApiMasterCompanyAddPostPath = '/api/Master/Company/Add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCompanyAddPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCompanyAddPost$Response(params?: ApiMasterCompanyAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyApiRespModel>> {
    return apiMasterCompanyAddPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCompanyAddPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCompanyAddPost(params?: ApiMasterCompanyAddPost$Params, context?: HttpContext): Observable<CompanyApiRespModel> {
    return this.apiMasterCompanyAddPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompanyApiRespModel>): CompanyApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterCompanyEditPost()` */
  static readonly ApiMasterCompanyEditPostPath = '/api/Master/Company/Edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCompanyEditPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCompanyEditPost$Response(params?: ApiMasterCompanyEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyApiRespModel>> {
    return apiMasterCompanyEditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCompanyEditPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCompanyEditPost(params?: ApiMasterCompanyEditPost$Params, context?: HttpContext): Observable<CompanyApiRespModel> {
    return this.apiMasterCompanyEditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompanyApiRespModel>): CompanyApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterCompanyDeleteGet()` */
  static readonly ApiMasterCompanyDeleteGetPath = '/api/Master/Company/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCompanyDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCompanyDeleteGet$Response(params?: ApiMasterCompanyDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StringApiRespModel>> {
    return apiMasterCompanyDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCompanyDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCompanyDeleteGet(params?: ApiMasterCompanyDeleteGet$Params, context?: HttpContext): Observable<StringApiRespModel> {
    return this.apiMasterCompanyDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringApiRespModel>): StringApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterCompanyGetAllGet()` */
  static readonly ApiMasterCompanyGetAllGetPath = '/api/Master/Company/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCompanyGetAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCompanyGetAllGet$Response(params?: ApiMasterCompanyGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Company>>> {
    return apiMasterCompanyGetAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCompanyGetAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCompanyGetAllGet(params?: ApiMasterCompanyGetAllGet$Params, context?: HttpContext): Observable<Array<Company>> {
    return this.apiMasterCompanyGetAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Company>>): Array<Company> => r.body)
    );
  }

  /** Path part for operation `apiMasterCompanyGetActiveGet()` */
  static readonly ApiMasterCompanyGetActiveGetPath = '/api/Master/Company/GetActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCompanyGetActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCompanyGetActiveGet$Response(params?: ApiMasterCompanyGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Company>>> {
    return apiMasterCompanyGetActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCompanyGetActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCompanyGetActiveGet(params?: ApiMasterCompanyGetActiveGet$Params, context?: HttpContext): Observable<Array<Company>> {
    return this.apiMasterCompanyGetActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Company>>): Array<Company> => r.body)
    );
  }

  /** Path part for operation `apiMasterCompanyGetByCriteriaPost()` */
  static readonly ApiMasterCompanyGetByCriteriaPostPath = '/api/Master/Company/GetByCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCompanyGetByCriteriaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCompanyGetByCriteriaPost$Response(params?: ApiMasterCompanyGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Company>>> {
    return apiMasterCompanyGetByCriteriaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCompanyGetByCriteriaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCompanyGetByCriteriaPost(params?: ApiMasterCompanyGetByCriteriaPost$Params, context?: HttpContext): Observable<Array<Company>> {
    return this.apiMasterCompanyGetByCriteriaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Company>>): Array<Company> => r.body)
    );
  }

  /** Path part for operation `apiMasterCompanyGetByIdGet()` */
  static readonly ApiMasterCompanyGetByIdGetPath = '/api/Master/Company/GetById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCompanyGetByIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCompanyGetByIdGet$Response(params?: ApiMasterCompanyGetByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Company>> {
    return apiMasterCompanyGetByIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCompanyGetByIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCompanyGetByIdGet(params?: ApiMasterCompanyGetByIdGet$Params, context?: HttpContext): Observable<Company> {
    return this.apiMasterCompanyGetByIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Company>): Company => r.body)
    );
  }

}
